import { render, staticRenderFns } from "./NfaList.vue?vue&type=template&id=6c58446b&scoped=true&"
import script from "./NfaList.vue?vue&type=script&lang=js&"
export * from "./NfaList.vue?vue&type=script&lang=js&"
import style0 from "./NfaList.vue?vue&type=style&index=0&id=6c58446b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58446b",
  null
  
)

export default component.exports